import { forwardRef } from 'react';
import BaseIconStyled from '../style';

const PrevIcon = forwardRef(({ children, color, variant, ...props }, ref) => {
  return (
    <BaseIconStyled {...props} color={color}>
      <path d="M18 2L6 12.4L18 22" />
    </BaseIconStyled>
  );
});

export default PrevIcon;
